import { Td, Tr } from 'app/components/Table';
import { SongCover } from 'app/components/Song/SongCover';
import { format } from 'date-fns';
import { dateFormats } from 'app/constants';
import { Credit } from 'types/api.types';
import { ListItemText } from 'app/components/ChakraTableList';
import { TruncatedChips } from 'app/components/Core/TruncatedChips';
import { ContributionClassRolesDDL } from 'types/contribution';
import { Role } from './types';
import { getChipRoleLabel } from '../../Contributions/ContributionsList/utils';
import { getOrderedRoles } from './utils';

interface CreditRowProps {
  credit: Credit;
  contributionClassNames?: ContributionClassRolesDDL;
  contributionRoles?: ContributionClassRolesDDL;
  onRowClick?: (credit: Credit) => void;
}

export const CreditRow = ({
  credit,
  contributionClassNames,
  contributionRoles,
  onRowClick,
}: CreditRowProps) => {
  const orderedRoles = getOrderedRoles(credit, contributionClassNames);
  const updatedAt = format(
    new Date(credit.updatedAt.iso),
    dateFormats.LIST_FORMAT
  );
  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      clickable
      onClick={() => onRowClick?.(credit)}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        <SongCover size="medium" status={credit.song.status} />
      </Td>
      <Td sx={{ pl: 0 }}>
        <ListItemText
          primary={credit.title}
          title={credit.title}
          data-testid="title"
        />
      </Td>
      <Td data-testid="roles">
        <TruncatedChips<Role>
          items={orderedRoles}
          getKey={(role) => role.guid}
          getLabel={(role) => getChipRoleLabel(role, contributionRoles)}
        />
      </Td>
      <Td>
        <ListItemText primary={updatedAt} data-testid="date" />
      </Td>
      <Td>
        <ListItemText
          primary={credit.addedBy.profile.displayName}
          title={credit.addedBy.profile.displayName}
          data-testid="added-by"
        />
      </Td>
      <Td className="gap" />
    </Tr>
  );
};
